import React from "react";
import { Link } from "react-router-dom";
import styles from "./startNow.module.css";

export function StartNow() {
  return (
    <main id="main" className="ui-page">
      <div className="ui-container">
        <header className="ui-page-header">
          <h1>Get started</h1>
          <p>
            Browse the starter kit, or contact us with questions.
          </p>
        </header>

        <div className={`ui-card ${styles.card}`}>
          <div className={styles.actions}>
            <Link to="/shopping" className="ui-btn ui-btn--full">
              View the starter kit
            </Link>
            <Link to="/contact" className="ui-btn ui-btn--secondary ui-btn--full">
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
